import { IconSVG } from '../types';

export const SentimentNeutral = ({ size, style }: IconSVG) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size}
      style={style}
      fill="none" 
      viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15.5 11q.624 0 1.063-.437Q17 10.125 17 9.5t-.437-1.062A1.45 1.45 0 0 0 15.5 8q-.625 0-1.062.438A1.45 1.45 0 0 0 14 9.5q0 .624.438 1.063.437.437 1.062.437m-7 0q.624 0 1.063-.437Q10 10.125 10 9.5t-.437-1.062A1.45 1.45 0 0 0 8.5 8q-.625 0-1.062.438A1.45 1.45 0 0 0 7 9.5q0 .624.438 1.063Q7.875 11 8.5 11m1.25 4.5h4.5a.73.73 0 0 0 .75-.75.73.73 0 0 0-.75-.75h-4.5a.73.73 0 0 0-.75.75.73.73 0 0 0 .75.75M12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
       />
    </svg>
  );
};